import {useMutation, useQueryClient} from "@tanstack/react-query";
import {saveContactApi} from "../../../../api/correspondent/contractApi";
import {ContactSaveType} from "../interface";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useModal} from "../../../../hooks";

type Props = {
    setRead: () => void;
    isCreate: boolean;
};

const useSaveContact = ({setRead, isCreate}: Props) => {
    const queryClient = useQueryClient();
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();

    const {mutate} = useMutation({
        mutationFn: (data: ContactSaveType) => saveContactApi(data),
        onSuccess: (res) => {
            console.log("연락처 저장", res);
            if (isCreate) {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => goToNavigation(
                        "customer/contact/detail/" + res?.result?.contactid,
                        {
                            contactId: res?.result?.contactid,
                            contactPath: res?.result?.contactPath,
                            department: res?.result?.department,
                            emailAddress1: res?.result?.emailAddress1,
                            fullName: res?.result?.fullName,
                            industryCategory: res?.result?.industryCategory,
                            jobTitle: res?.result?.jobTitle,
                            mobilePhone: res?.result?.mobilePhone,
                            newTxtTeam: res?.result?.newTxtTeam,
                            stateCode: res?.result?.stateCode,
                            telephone1: res?.result?.telephone1,
                        },
                        false
                    )
                })
                console.log(res?.result?.contactid);
                setRead();
            } else {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => setRead()
                })
                queryClient.invalidateQueries({queryKey: ["readContactDetail"]});
            }
        },
        onError: (error) => {
            console.error("연락처 저장 실패", error);
        },
    });
    return {mutate};
};

export default useSaveContact;
